export const SportIdMapping = {
	'0': 'others',
	'1': 'soccer',
	'-1': 'coming-soon',
};
export const EventTab = {
	'member': 'member',
	'task': 'task'
}
export const rewardMockData = [
	{
		'VipLevelName': 'lbl_RPReward5', //vip等級名稱(i18n key)
		'LevelUpExp': 10,
		'Privileges': [ //這個等級可以得到的特權
			{
				'SportType': '1', // other = 0
				'Rebate': -1, //返水比例
			},
			{
				'SportType': '0', // other = 0
				'Rebate': -1
			},
			{
				'SportType': '-1', // 即將解鎖
				'Rebate': -1
			}
		]
	},
	{
		'VipLevelName': 'lbl_RPReward6', //vip等級名稱(i18n key)
		'LevelUpExp': 10,
		'Privileges': [ //這個等級可以得到的特權
			{
				'SportType': '1', // other = 0
				'Rebate': -1, //返水比例
			},
			{
				'SportType': '0', // other = 0
				'Rebate': -1
			},
			{
				'SportType': '-1', // 即將解鎖
				'Rebate': -1
			},
			{
				'SportType': '-1', // 即將解鎖
				'Rebate': -1
			}
		]
	},
	{
		'VipLevelName': 'lbl_RPReward7', //vip等級名稱(i18n key)
		'LevelUpExp': 10,
		'Privileges': [ //這個等級可以得到的特權
			{
				'SportType': '1', // other = 0
				'Rebate': -1, //返水比例
			},
			{
				'SportType': '0', // other = 0
				'Rebate': -1
			},
			{
				'SportType': '-1', // 即將解鎖
				'Rebate': -1
			},
			{
				'SportType': '-1', // 即將解鎖
				'Rebate': -1
			},
			{
				'SportType': '-1', // 即將解鎖
				'Rebate': -1
			}
		]
	},
]

export const rankingMockData = [
	{
		'CustId': 35195579,
		'CustName': 'w888_aaaaa',
		'TotalExp': 9999999	
	},
	{
		'CustId': 35195578,
		'CustName': 'mm_test',
		'TotalExp': 9999998	
	},
	{
		'CustId': 35195577,
		'CustName': 'lena_test',
		'TotalExp': 9999997	
	},
	{
		'CustId': 444444,
		'CustName': '123',
		'TotalExp': 7725	
	},
	{
		'CustId': 35195579,
		'CustName': '222_gggggg',
		'TotalExp': 1002	
	},
	{
		'CustId': 222222,
		'CustName': 'test1',
		'TotalExp': 155	
	}
]